export const getters = {
	notifications: state => state.notifications
}



// WEBPACK FOOTER //
// ./src/store/modules/Notifications/getters.js